<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="guidance-welcome"
    >
      <div class="guidance-welcome__backdrop" />
      <div class="guidance-welcome__card">
        <div class="guidance-welcome__header">
          <div class="guidance-welcome__logo-ring">
            <img
              src="/icons/eplex_logo_icon.png"
              class="guidance-welcome__logo"
              alt="Eplex"
            />
          </div>
          <h2 class="guidance-welcome__title">
            {{ t("guidance.welcomeTitle") }}
          </h2>
          <p class="guidance-welcome__subtitle">Eplex Web</p>
        </div>
        <div class="guidance-welcome__body">
          <p class="guidance-welcome__text">
            {{ t("guidance.welcomeDescription") }}
          </p>
          <div class="guidance-welcome__features">
            <div class="guidance-welcome__feature">
              <span class="guidance-welcome__feature-icon">
                <i class="dx-icon-search" />
              </span>
              <span class="guidance-welcome__feature-text">{{ t("guidance.welcomeFeature1") }}</span>
            </div>
            <div class="guidance-welcome__feature">
              <span class="guidance-welcome__feature-icon">
                <i class="dx-icon-cart" />
              </span>
              <span class="guidance-welcome__feature-text">{{ t("guidance.welcomeFeature2") }}</span>
            </div>
          </div>
          <p class="guidance-welcome__cta">
            {{ t("guidance.welcomeCta") }}
          </p>
          <p
            v-if="kind === 'onboarding'"
            class="guidance-welcome__tokens-note"
          >
            {{ t("guidance.welcomeTokensNote") }}
          </p>
        </div>
        <div class="guidance-welcome__actions">
          <DxButton
            :text="t('guidance.welcomeSkip')"
            type="normal"
            styling-mode="outlined"
            @click="emit('skip')"
          />
          <DxButton
            :text="t('guidance.welcomeStart')"
            type="default"
            styling-mode="contained"
            @click="emit('start')"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import DxButton from "devextreme-vue/button";
import type { GuidanceKind } from "../models/guidance/GuidanceTypes";

interface Props {
  visible: boolean;
  kind: GuidanceKind;
}

defineProps<Props>();

const emit = defineEmits<{
  start: [];
  skip: [];
}>();

const { t } = useI18n();
</script>
